import { render, staticRenderFns } from "./ExtratoItem.vue?vue&type=template&id=ecc45bba&scoped=true"
import script from "./ExtratoItem.vue?vue&type=script&lang=js"
export * from "./ExtratoItem.vue?vue&type=script&lang=js"
import style0 from "./ExtratoItem.vue?vue&type=style&index=0&id=ecc45bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc45bba",
  null
  
)

export default component.exports